export default __webpack_public_path__ + "static/assets/check.56b6b19c.svg";